// extracted by mini-css-extract-plugin
export default {"productTypesList":"LkmProductTypesList_productTypesList__XYOTU","productTypesList__item":"LkmProductTypesList_productTypesList__item__WhFHH"};